module.exports = __webpack_public_path__ + "img/cards_n2.cbd293af.png";